export const ROUTES = {
  PAYMENT: {
    NAME: 'payment',
    PATH: '/payment/:isn/:hash',
  },
  STATUS: {
    NAME: 'status',
    PATH: '/status/:isn/:hash',
  },
  NOT_FOUND: {
    NAME: 'not-found',
    PATH: '/:pathMatch(.*)*',
  },
} as const
